// import React from 'react';
// import Pdfcontain from '../../service/components/Pdfcontain';
// import Estimatecell from '../../service/components/Estimatecell';
// import { useState } from 'react';

// function Out_estimate({ imageSrcs, offerlist, detailProject, detail }) {
//   const [hidden, setHidden] = useState(false)
//   const onClick = () => {
//     setHidden(!hidden)
//   }
//   return (

//     <div className='add_right_wrap outwrap'>

//       <Pdfcontain list={detail.estimate} single={true} type={'estimate'} file={imageSrcs.base64} />
//       <Estimatecell array={offerlist} detailProject={detailProject} />
//       {detail && detail.uid === 'exampledata' ?
//         <div className='text_absolute'>
//           견적서 예시입니다
//         </div>
//         : null
//       }
//     </div>
//   );
// }

// export default Out_estimate;

//////////////////////20260331/////////////////////////////

import React from 'react'
import Pdfcontain from '../../service/components/Pdfcontain'
import Estimatecell from '../../service/components/Estimatecell'
import { useState } from 'react'
import { STEP } from '../Project/projectStepManager'

function Out_estimate({ imageSrcs, offerlist, detailProject, detail }) {
    const [hidden, setHidden] = useState(false)

    const onClick = () => {
        setHidden(!hidden)
    }

    function getStepOrder(step) {
        var orderMap = {}

        orderMap[STEP.TEMP] = 0
        orderMap[STEP.REGISTER] = 1
        orderMap[STEP.ESTIMATE_WRITE] = 2
        orderMap[STEP.ESTIMATE_RECEIVE] = 3
        orderMap[STEP.ESTIMATE_APPROVE] = 4
        orderMap[STEP.CONTRACT_WRITE] = 5
        orderMap[STEP.CONTRACT_SIGN] = 6
        orderMap[STEP.DEPOSIT] = 7
        orderMap[STEP.DEV1] = 8
        orderMap[STEP.MIDDLE] = 9
        orderMap[STEP.DEV2] = 10
        orderMap[STEP.FINAL_REPORT] = 11
        orderMap[STEP.FINAL_PAY] = 12
        orderMap[STEP.DONE] = 13

        if (typeof orderMap[step] === 'number') {
            return orderMap[step]
        }

        return -1
    }

    function canViewEstimate(step) {
        return getStepOrder(step) >= getStepOrder(STEP.ESTIMATE_RECEIVE)
    }

    var currentStep = detailProject && detailProject.adminstatus ? detailProject.adminstatus : ''

    var canViewRealEstimate = canViewEstimate(currentStep)
    var forceExample = !canViewRealEstimate || (detail && detail.uid === 'exampledata')

    return (
        <div className="add_right_wrap outwrap">
            <Pdfcontain
                list={detail && detail.estimate ? detail.estimate : ''}
                single={true}
                type={'estimate'}
                file={imageSrcs && imageSrcs.base64 ? imageSrcs.base64 : ''}
            />
            <Estimatecell array={offerlist} detailProject={detailProject} />
            {forceExample ? <div className="text_absolute">견적서 예시입니다</div> : null}
        </div>
    )
}

export default Out_estimate
